import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  IconButton,
} from "@mui/material";
import { CheckCircle, Cancel, Edit, Delete } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  DeletetUser,
  GetUserChildPermission,
  GetUsers,
} from "../../../redux/Actions/userStatusService";
import RemoveUserPopup from "../../../Modals/AddUserPopup/RemoveUserPopup";
import EditUserPopup from "../../../Modals/AddUserPopup/EditUserPopup";

function Users({ portal }) {
  const dispatch = useDispatch();
  const { users, userPermissions, userInformation } = useSelector(
    (state) => state.userStatus || []
  );

  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userPerm, setUserPerm] = useState({});
  const [openRemovePopup, setOpenRemovePopup] = useState(false);
  const [openEditPopup, setOpenEditPopup] = useState(false);

  useEffect(() => {
    dispatch(GetUsers(portal));
  }, [dispatch, portal]);

  useEffect(() => {
    if (users) {
      setData(users);
    }
  }, [users]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEdit = async (row) => {
    setSelectedUser(row);
    try {
      const response = await dispatch(
        GetUserChildPermission({ childRoleId: row?.childUserRole?.id, type: portal })
      );
      if (response?.payload?.statusCode === 200) {
        setUserPerm(response?.payload?.data);
      } else {
        console.error("Failed to delete user:", response?.payload);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }

    setOpenEditPopup(true);
  };

  const handleDelete = (row) => {
    setSelectedUser(row);
    setOpenRemovePopup(true);
  };
  const handleConfirmDelete = async () => {
    try {
      const response = await dispatch(
        DeletetUser({ id: selectedUser?.childUserRole?.id, role: portal })
      );

      if (response?.payload?.statusCode === 200) {
        const updatedUsersResponse = await dispatch(GetUsers(portal));
        if (updatedUsersResponse?.payload?.statusCode === 200) {
          setData(updatedUsersResponse.payload.data);
        }
      } else {
        console.error("Failed to delete user:", response?.payload);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }

    setOpenRemovePopup(false);
  };

  return (
    <TableContainer component={Paper} style={{ padding: "10px" }}>
      <Table>
        <TableHead style={{ fontWeight: "normal", fontSize: "8px" }}>
          <TableRow>
            <TableCell><p style={{ fontWeight: "normal", fontSize: "18px" }}>Sno</p></TableCell>
            <TableCell><p style={{ fontWeight: "normal", fontSize: "18px" }}>Email</p></TableCell>
            <TableCell><p style={{ fontWeight: "normal", fontSize: "18px" }}>Date</p></TableCell>
            <TableCell ><p style={{ fontWeight: "normal", fontSize: "18px" }}>Role </p></TableCell>
            <TableCell ><p style={{ fontWeight: "normal", fontSize: "18px" }}>isActive</p></TableCell>
            <TableCell ><p style={{ fontWeight: "normal", fontSize: "18px" }}>Actions</p></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => (
              <TableRow key={row?.id}>
                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                <TableCell>{row?.childUserRole?.user?.email}</TableCell>
                <TableCell>
                  {new Date(row?.createdAt).toLocaleString()}
                </TableCell>
                <TableCell>{row?.childUserRole?.role}</TableCell>
                <TableCell>
                  {row?.isActive ? <CheckCircle /> : <Cancel />}
                </TableCell>
                <TableCell>
                  <IconButton
                    onClick={() => handleEdit(row)}
                    color="primary"
                    size="small"
                  >
                    <Edit fontSize="small" />
                  </IconButton>
                  <IconButton
                    onClick={() => handleDelete(row)}
                    color="secondary"
                    size="small"
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={data?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <RemoveUserPopup
        open={openRemovePopup}
        onClose={() => setOpenRemovePopup(false)}
        onConfirm={handleConfirmDelete}
      />
      <EditUserPopup
        open={openEditPopup}
        onClose={() => setOpenEditPopup(false)}
        selectedUser={selectedUser}
        portal={portal}
        userInformation={userInformation}
        userPermissions={userPermissions}
        userPerm={userPerm}
      />
    </TableContainer>
  );
}

export default Users;
